export class AtlasFormFieldErrors {
  private errors: Map<string, string> = new Map<string, string>();

  getErrors(): Map<string, string> {
    return this.errors;
  }

  getErrorMessage(key: string): string {
    return this.errors.get(key) || '';
  }

  setError(key: string, message: string): void {
    this.errors.set(key, message);
  }
}
